export default __webpack_public_path__ + "static/media/BG _Circle.22b4eba8.png";